export default {
  COMMON__MINUTES: 'น.',
  SENDBIRD: {
    BADGE__OVER: '+',
    MESSAGE_MENU__EDIT: 'แก้ไข',
    BUTTON__DELETE: 'ลบ',
    MESSAGE_STATUS__DELETE: 'ลบ',
    MESSAGE_MENU__DELETE: 'ลบ',
    BUTTON__SAVE: 'บันทึก',
    BUTTON__CANCEL: 'ยกเลิก',
    BUTTON__CLOSE: 'ปิด',
    MODAL__CHANNEL_INFORMATION__UPLOAD: 'อัปโหลด',
    EDIT_PROFILE__IMAGE_UPLOAD: 'อัปโหลด',
    CHANNEL_LIST__TITLE: 'ช่อง',
    CHANNEL_SETTING__HEADER__TITLE: 'ข้อมูลช่อง',
    MODAL__USER_LIST__TITLE: 'สมาชิก',
    CHANNEL_SETTING__MEMBERS__TITLE: 'สมาชิก',
    NO_MEMBERS: '(ไม่มีสมาชิก)',
    NO_NAME: '(ไม่มีชื่อ)',
    TOOLTIP__UNKOWN_USER: '(ไม่มีชื่อ)',
    CHANNEL_SETTING__LEAVE_CHANNEL__TITLE: 'ออกจากช่อง',
    BUTTON__INVITE: 'เชิญชวน',
    MODAL__INVITE_MEMBER__SELECTED: 'เลือกแล้ว',
    MODAL__CREATE_CHANNEL__SELECTED: 'เลือกแล้ว',
    MODAL__CHANNEL_INFORMATION__CHANNEL_NAME: 'ชื่อช่อง',
    MODAL__INVITE_MEMBER__TITLE: 'เชิญสมาชิก',
    CHANNEL__MESSAGE_INPUT__PLACE_HOLDER: 'ป้อน',
    MESSAGE_INPUT__PLACE_HOLDER: 'ป้อน',
    BUTTON__CREATE: 'สร้าง',
    MODAL__CREATE_CHANNEL__TITLE: 'ช่องใหม่',
    TRYING_TO_CONNECT: 'กำลังพยายามเชื่อมต่อ...',
    USER_PROFILE__MESSAGE: 'ข้อความ',
    USER_PROFILE__USER_ID: 'ไอดีผู้ใช้',
    EDIT_PROFILE__USERID_LABEL: 'ไอดีผู้ใช้',
    EDIT_PROFILE__TITLE: 'โปรไฟล์ของฉัน',
    EDIT_PROFILE__IMAGE_LABEL: 'รูปภาพโปรไฟล์',
    EDIT_PROFILE__NICKNAME_LABEL: 'ชื่อเล่น',
    EDIT_PROFILE__THEME_LABEL: 'ธีมมืด',
    CHANNEL__MESSAGE_INPUT__PLACE_HOLDER__DISABLED: 'ไม่สามารถใช้งานแชทได้ในช่องนี้',
    CHANNEL__MESSAGE_LIST__NOTIFICATION__NEW_MESSAGE: 'ข้อความใหม่ตั้งแต่',
    CHANNEL__MESSAGE_LIST__NOTIFICATION__ON: 'เมื่อ',
    CHANNEL_SETTING__MEMBERS__SEE_ALL_MEMBERS: 'สมาชิกทั้งหมด',
    CHANNEL_SETTING__MEMBERS__INVITE_MEMBER: 'เชิญผู้ใช้',
    MODAL__DELETE_MESSAGE__TITLE: 'ลบข้อความนี้หรือไม่',
    MODAL__CHANNEL_INFORMATION__TITLE: 'แก้ไขข้อมูลช่อง',
    MODAL__CHANNEL_INFORMATION__CHANNEL_IMAGE: 'รูปภาพของช่อง',
    MODAL__CHANNEL_INFORMATION__INPUT__PLACE_HOLDER: 'ป้อนชื่อ',
    TYPING_INDICATOR__IS_TYPING: 'กำลังพิมพ์...',
    TYPING_INDICATOR__ARE_TYPING: 'กำลังพิมพ์...',
    TYPING_INDICATOR__MULTIPLE_TYPING: 'กำลังพิมพ์...',
    TYPING_INDICATOR__AND: 'และ',
    MESSAGE_STATUS__SENDING_FAILED: 'ไม่สามารถส่งข้อความได้',
    MESSAGE_STATUS__TRY_AGAIN: 'ลองอีกครั้ง',
    MESSAGE_STATUS__OR: 'หรือ',
    PLACE_HOLDER__WRONG: 'มีข้อผิดพลาด',
    PLACE_HOLDER__RETRY_TO_CONNECT: 'ลองอีกครั้ง',
    NO_TITLE: 'ไม่มีชื่อ',
    TOOLTIP__AND_YOU: 'และคุณ',
    TOOLTIP__YOU: 'คุณ',
    UNKNOWN__UNKNOWN_MESSAGE_TYPE: '(ไม่ทราบประเภทข้อความ)',
    UNKNOWN__CANNOT_READ_MESSAGE: 'ไม่สามารถอ่านข้อความนี้ได้',
    MESSAGE_EDITED: '(แก้ไขแล้ว)',
    PLACE_HOLDER__NO_CHANNEL: 'เริ่มการสนทนาใหม่',
    MESSAGE_MENU__REPLY: 'ตอบ',
    QUOTED_MESSAGE__REPLIED_TO: '→',
    QUOTE_MESSAGE_INPUT__REPLY_TO: '',
    QUOTED_MESSAGE__CURRENT_USER: 'คุณ',
    MESSAGE_INPUT__QUOTE_REPLY__PLACE_HOLDER: 'ตอบกลับ',
    CHANNEL_SETTING__PROFILE__EDIT: 'แก้ไข',
    MESSAGE_MENU__COPY: 'คัดลอก',
  },
  TERMS_IMPRESSUM: 'Impressum',
  TERMS_DATENSCHUTZ: 'Datenschutz',
  CONFIRM: 'ตกลง',
  SETTINGS__NONE: 'ไม่มี',
  SEARCH__USER_PLACEHOLDER: 'ชื่อ/หมายเลขพนักงาน/หมายเลขโทรศัพท์',
  SEARCH__NO_USER_INFO: 'ไม่มีข้อมูลผู้ใช้',
  LOGIN__EMAIL_OR_HP: 'อีเมลหรือหมายเลขโทรศัพท์',
  ELECTRON: {
    MENU_DELETE: 'ลบ',
    MENU_VIEW: 'ดู',
    MENU_SIGN_OUT: 'ออกจากระบบ',
    MENU_SETTINGS: 'การตั้งค่า',
    MENU_CLOSE: 'ปิด',
    MENU_SELECT_ALL: 'เลือกทั้งหมด',
    MENU_FILE: 'ไฟล์',
    MENU_ABOUT: 'เกี่ยวกับ {0}',
    MENU_UPDATE: 'ตรวจสอบการอัปเดต',
    MENU_HIDE: 'ซ่อน {0}',
    MENU_HIDE_OTHERS: 'ซ่อนคนอื่นๆ',
    MENU_SHOW_ALL: 'แสดงทั้งหมด',
    MENU_QUIT: 'ออกจาก {0}',
    MENU_NEW_CHANNEL: 'ช่องใหม่',
    MENU_UNDO: 'ยกเลิก',
    MENU_REDO: 'ทำซ้ำ',
    MENU_CUT: 'ตัด',
    MENU_PASTE: 'วาง',
    MENU_PASTE_AND_MATCH_STYLE: 'วางสไตล์',
    MENU_RELOAD: 'โหลดใหม่',
    MENU_FORCE_RELOAD: 'บังคับให้โหลดใหม่',
    MENU_FULL_SCREEN: 'เปลี่ยนเป็นเต็มหน้าจอ',
    MENU_RESET_ZOOM: 'ขนาดจริง',
    MENU_ZOOM_IN: 'ซูมเข้า',
    MENU_ZOOM_OUT: 'ซูมอออก',
    MENU_WINDOW: 'หน้าต่าง',
    MENU_MINIMIZE: 'ย่อ',
    MENU_ZOOM: 'ขยาย',
    MENU_HELP: 'ช่วยเหลือ',
    MESSAGE_UP_TO_DATE: 'คุณกำลังใช้เวอร์ชันล่าสุด',
    UPDATE_AVAILABLE: 'แอปพร้อมให้อัปเดตแล้ว',
    MESSAGE_UPDATE_AVAILABLE: 'การอัปเดตเป็นเวอร์ชันล่าสุดพร้อมแล้ว',
    MENU_EDIT: 'แก้ไข',
    MENU_COPY: 'คัดลอก',
    UP_TO_DATE: 'เวอร์ชั่นล่าสุด',
  },
  LOGIN__INSERT_EMAIL_HP: 'ป้อนอีเมลหรือหมายเลขโทรศัพท์ของคุณ',
  LOGIN__PASSWORD_GUIDE_SUBTITLE: 'หากคุณลืมรหัสผ่าน โปรดรีเซ็ตรหัสผ่านบนหน้าเข้าสู่ระบบของแอปมือถือ',
  LOGIN__INSERT_PASSWORD: 'โปรดป้อนรหัสผ่าน',
  LOGIN__PASSWORD_INFORMATION: 'ลืมรหัสผ่านของคุณใช่ไหม',
  BEFORE: 'ก่อน',
  ALERT__NO_ONE_SELECTED: 'ยังไม่ได้เลือกใคร',
  BASIC__: {
    ERROR: 'เกิดข้อผิดพลาด <br /> โปรดลองใหม่อีกครั้ง',
    MSG__: { INPUT: 'ค้นหาโดยใช้คีย์เวิร์ด' },
    PWD_ALL_VALIDATION: 'รหัสผ่านต้องเป็นตัวอักษรพิมพ์เล็ก/ใหญ่ ตัวเลข และอักขระพิเศษรวมกัน %1$@~%2$@ ตัว',
    RETRY: 'ลองอีกครั้ง',
    PASSWORD_RULE: '8-20 ตัวอักษร และประกอบด้วยอักษร ตัวเลข และสัญลักษณ์',
    HAS_ATTENDANCE_HISTORY_VIEW_RIGHT: 'อนุญาตให้ดูประวัติเข้างานส่วนบุคคลหรือไม่',
  },
  LOGOUT: 'ออกจากระบบ',
  COMMON__SECONDS: 'วินาที',
  SCHEDULE__: {
    GUIDE__: {
      IF_YOU_STOP_UNSAVED: 'หากคุณหยุดแก้ไข การเปลี่ยนแปลงที่ไม่ได้บันทึกจะสูญหายไป',
      ARE_YOU_SURE_WANT_TO_STOP: 'คุณแน่ใจหรือไม่ว่าต้องการหยุดแก้ไขกำหนดการ',
    },
  },
  TEMPLATE__: { GUIDE__: { NO_TEMPLATE_REGISTERED: 'ไม่มีเทมเพลตที่ลงทะเบียน' } },
  AWAY_TIME: 'ชม.',
  SETTINGS__CHANGE_LANGUAGE: 'ภาษา',
  SEARCH__MEMBER_PLACEHOLDER: 'ชื่อ/หมายเลขพนักงาน/หมายเลขโทรศัพท์',
  ' ': "ถ้าตั้งค่าเป็น 'ไม่ใช้' ฟีเจอร์การจัดการการตั้งครรภ์/หลังคลอดจะถูกปิดและคุณจะไม่สามารถดูบันทึกที่เกี่ยวข้องได้",
  BASIC__UNKNOWN: 'ไม่ทราบ',
  LOGIN__SERVER_ALERT: 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
  MSG__: {
    ERROR__: {
      UPDATE_CHANNEL_INFO: 'ไม่สามารถอัปเดตช่องได้',
      LEAVE_CHANNEL: 'ไม่สามารถออกจากช่องได้',
      CREATE_CHANNEL: 'ไม่สามารถสร้างช่องได้',
    },
    FILE__: { MAXIMGSIZE: 'เกินขนาดไฟล์ที่กำหนด' },
    ALLOW_BROWSER_ALARM: 'อนุญาตการแจ้งเตือนในการตั้งค่าเบราว์เซอร์ของคุณเพื่อรับข้อความแจ้งเตือน',
    LABEL__: { SEARCH_MESSAGE: 'ค้นหาข้อความ' },
    GUIDE__: { SEARCH_MESSAGE: 'ค้นหาข้อความที่คุณต้องการหาใน {0}' },
    BASIC__: { NO_SEARCH_RESULT: 'ไม่มีผลลัพธ์' },
  },
  INVITE__MEMBER_SELECTION: 'เลือกสมาชิก',
  CHANNEL__EDIT_CHANNEL_NAME_GUIDE: 'ผู้เข้าร่วมทุกคนจะเห็นการเปลี่ยนชื่อ',
  NOTICE: 'การแจ้งเตือน',
  INVITE__CREATE: 'สร้าง',
  CHANNEL__LEAVE_THIS_CHANNEL: 'ออกจากช่องหรือไม่',
  LOGIN__PASSWORD_FAIL_COUNT: 'คุณได้ป้อนรหัสผ่านที่ไม่ถูกต้อง {0} ครั้ง',
  LOGIN__FAIL_ALERT: 'บัญชีจะถูกล็อก 5 นาทีหลังจากที่ป้อนรหัสผ่านผิด 5 ครั้งติดต่อกัน',
  LOGIN__LOCK_STATE_ALERT: 'ล็อคเป็นเวลา 5 นาทีเนื่องจากการป้อนรหัสผ่านผิดติดต่อกัน',
  LOGIN__RETRY_ALERT: 'โปรดลองอีกครั้งใน {0}',
  LOGIN__PASSWORD_GUIDE_TITLE: 'รหัสผ่านของ ShoplChat จะเหมือนกับรหัสผ่านของแอปโทรศัพท์มือถือ',
  SETTINGS__ALL_MESSAGES: 'การแจ้งเตือนข้อความใหม่ทั้งหมด',
  SETTINGS__ALARM_SOUND: 'เสียง',
  SETTINGS__SOUND_ALARM: 'เสียงแจ้งเตือน',
  SETTINGS__LISTEN_ALARM_SOUND: 'ฟัง',
  ALERT__MAX_INVITE_MEMBER: 'จำนวนพนักงานสูงสุดที่สามารถเข้าร่วมช่องได้คือ 20,000 คน',
  LOGIN__DEACTIVATED_ALERT: 'ไม่สามารถเข้าสู่ระบบได้เนื่องจากผู้ดูแลปิดฟีเจอร์การแชท',
  LOGIN__SERVER_ALERT_CONTENTS: 'ไม่สามารถเข้าสู่ระบบได้ โปรดตรวจสอบการเชื่อมต่ออินเทอร์เน็ตของคุณ แล้วลองอีกครั้ง',
  LOGIN__LOGOUT_ALERT: 'คุณออกจากระบบแล้ว',
  CHANNEL__EDIT_CHANNEL_NAME: 'เปลี่ยนชื่อช่อง',
  SETTINGS__THEME: 'ธีม',
  SETTINGS__LANGUAGE: 'ภาษา',
  SETTINGS__LIGHT_THEME: 'สว่าง',
  SETTINGS__DARK_THEME: 'มืด',
  SEARCH__CHANNEL_PLACEHOLDER: 'พนักงาน',
  CHANNEL__CONTACT: 'แชท 1:1',
  BASIC: { LABEL: { MAXIMAGECNT: 'สามารถอัปโหลดได้สูงสุด {0} ภาพ' } },
  LOGIN__LOGIN_FAILED: 'ID หรือรหัสผ่านไม่ถูกต้อง',
  FORGOT_PW: 'ลืมรหัสผ่านของคุณใช่ไหม',
  BASIC__MAX_FORMAT_INPUT: 'สามารถป้อนได้สูงสุด %@ ตัวอักษร',
  SERVICE__COMING_SOON: 'เร็วๆ นี้',
  LOGIN__GUIDE: 'คุณสามารถเข้าสู่ระบบได้โดยใช้บัญชีที่ใช้บนแอป',
  MOBILE__: {
    ACCESS_PC: 'เข้าใช้งานแดชบอร์ด(PC)จาก PC!',
    ACCESS_DESC_01: 'แดชบอร์ด(PC)ถูกปรับแต่งให้เข้ากับสภาพแวดล้อมของ PC',
    ACCESS_DESC_02: 'ลองเข้าใช้งานจาก PC เพื่อประสบการณ์ที่ดีที่สุดสำหรับคุณ',
    ACCESS_PC_ONLY: 'ลองเข้าใช้งานจาก PC',
    GUIDE: 'ฟีเจอร์การแชทสามารถใช้ได้บน PC หรือแอปมือถือของคุณ',
  },
  CHANNEL__NO_CHAT_HISTORY: 'ไม่มีการสนทนา',
  LOGIN: 'เข้าสู่ระบบ',
  LOGIN__PASSWORD: 'รหัสผ่าน',
  SEARCH__NO_RESULT: 'ไม่มีผลลัพธ์',
  BASIC__SEARCH: 'ค้นหา',
};
